import GalleryHero from "../Components/Galleryhero";
import Pictures from "../Components/Pictures";

const Gallerypage = () => {
  return (
    <>
    <section id="GalleryHero">
        <GalleryHero />
      </section>

      <section id="Pictures">
        <Pictures />
      </section>

     
    </>
  );
};

export default Gallerypage;
